import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./ContactAgent.html';
import styles from './ContactAgent-hashed.scss';
import controller from './ContactAgentCtrl';

export default {
    template: cssUtil.hashTemplate(template, styles),
    controller
};